<template>
  <div class="lesson-card">
    <Avatar :size="50" :url="`${BASE_PATH}${avatar}`"></Avatar>
    <div class="lesson-card-main display-flex flex-column">
      <div class="lesson-card-username">{{ name }}</div>
      <div class="lesson-card-message">
        <span>{{ lastMessageType === 'sent' ? 'You:' : '' }}</span>
        {{ lastMessage }}
      </div>
    </div>

    <div class="lesson-card-badge">
      <f7-badge>{{ minutes | two_digits }}:{{ seconds | two_digits }}</f7-badge>
      <f7-button fill class="gradient" @click="finishLesson">Finish</f7-button>
      <f7-button :href="`/user-history-list/${userId}`" fill class="gradient">History</f7-button>
    </div>
  </div>
</template>

<script>
import { BASE_PATH } from '@/js/constants/index.js';
import notify from '@/js/helpers/notify.js';

import Avatar from '@/components/Avatar.vue';
// import Countup from '@/components/Countup.vue';

export default {
  name: 'LessonCard',

  components: {
    Avatar
    // Countup
  },

  props: {
    id: {
      type: [String, Number],
      required: true
    },

    userId: {
      type: [String, Number],
      required: true
    },

    name: {
      type: String,
      default: ''
    },

    start: {
      type: [String, Date],
      default: ''
    },

    avatar: {
      type: String,
      default: ''
    },

    lastMessage: {
      type: [String, Number],
      default: null
    },

    // eslint-disable-next-line vue/require-default-prop
    lastMessageType: {
      type: String
    }
  },

  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000)
    };
  },

  computed: {
    BASE_PATH: () => BASE_PATH,

    startInMilliseconds() {
      return Math.trunc(new Date(this.start).getTime() / 1000);
    },

    seconds() {
      return (this.now - this.startInMilliseconds) % 60;
    },

    minutes() {
      return Math.trunc((this.now - this.startInMilliseconds) / 60) % 60;
    }
  },

  mounted() {
    const interval = setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);
    }, 1000);

    this.$once('hook:beforeDestroy', () => {
      clearInterval(interval);
    });
  },

  methods: {
    async finishLesson() {
      try {
        await this.$store.dispatch('lesson/finishLesson', { id: this.id });

        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.customeError) {
          notify({ text: error.customeError });
        }
        console.error('ERROR_IN:finishLesson', `MSG:${error.customeError || error.message}`);
      }
    }
  }
};
</script>

<style lang="scss">
.lesson-card {
  width: 100%;
  display: flex;
  align-items: center;

  &-main {
    width: 154px;
  }

  .avatar {
    margin-right: 10px;
  }

  &-username {
    margin-bottom: 3px;
    font-size: 15px;
    color: #000000;
    line-height: 1.07;
  }

  &-message {
    max-width: 80%;
    width: 100%;
    overflow: hidden;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(#5a6169, 0.6);

    span {
      color: #5a6169;
    }
  }

  .badge {
    background-color: rgb(190, 198, 211);
    font-size: 11px;
    font-weight: 700;
    padding: 0;
    flex-shrink: 0;
    width: 55px;
    margin-left: auto;
  }
}

.lesson-card-badge {
  .button {
    margin-top: 3px;
    height: 22px;
    line-height: 22px;
    border-radius: var(--f7-badge-size);
    font-size: 11px;
    font-weight: 700;
    background-color: var(--f7-color-blue) !important;

    &.active-state {
      background-color: var(--f7-color-blue-tint);
    }
  }
}
</style>
